/**
 * @template {import("@sentry/react-router").Event} T
 * @param {T} event
 * @returns {T}
 */
export function scrubSentryRequestCredentials(event) {
  if (event.request) {
    delete event.request.cookies;
    for (const header of Object.keys(event.request.headers ?? {})) {
      if (/^(cookie|set-cookie|authorization|proxy-authorization)$/i.test(header)) {
        delete event.request.headers[header];
      }
    }
  }
  return event;
}
